export const SECURITY_QUESTIONS = [
  'What was the name of your first pet?',
  'What is your mother\'s maiden name?',
  'What was the name of your first school?',
  'What is your favorite childhood memory?',
  'What city were you born in?',
  'What is your favorite book?',
  'What was your childhood nickname?',
  'What is the name of your favorite teacher?',
  'What street did you grow up on?',
  'What is your favorite movie?',
  'What was your first job?',
  'What is your favorite food?',
];